import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitopanchganicab() {



const cardData = {
  keyword: "Mumbai to Panchgani Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Panchgani cab services for travelers planning a relaxing hill station getaway in the Western Ghats. Whether you are planning a weekend trip, family vacation, romantic outing, or group excursion, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in hill and highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Panchgani cab services.",

topPlaces: [
  {
    title: "Table Land",
    description:
      "Table Land is a vast volcanic plateau in Panchgani, offering panoramic views of the surrounding hills and valleys. Visitors can enjoy horse riding, photography, and leisurely walks along the plateau. Traveling by cab ensures a comfortable journey from Mumbai and allows visitors to spend ample time exploring this natural attraction without worrying about local transport or parking."
  },
  {
    title: "Panchgani Sunset Point",
    description:
      "Panchgani Sunset Point is famous for breathtaking views of the sun setting over the Sahyadri hills. Visitors can relax, take photographs, and enjoy the peaceful atmosphere. A cab ride provides convenient access, allowing travelers to reach the viewpoint comfortably and plan their sightseeing itinerary efficiently."
  },
  {
    title: "Sydney Point",
    description:
      "Sydney Point offers spectacular views of the Krishna Valley and Dhom Dam. Visitors can enjoy nature walks, photography, and serene surroundings. Traveling by cab ensures safe and hassle-free access, giving travelers enough time to explore the viewpoint at leisure."
  },
  {
    title: "Parsi Point",
    description:
      "Parsi Point is a scenic spot overlooking the Krishna Valley, ideal for photography, picnics, and relaxation. Visitors can enjoy the cool breeze and panoramic views. A cab service allows travelers to reach Parsi Point comfortably and integrate it into a full day’s sightseeing in Panchgani."
  },
  {
    title: "Rajpuri Caves",
    description:
      "Rajpuri Caves are ancient rock-cut caves near Panchgani, known for their historical significance and peaceful surroundings. Visitors can explore the caves, enjoy nature walks, and learn about local history. Using a cab ensures convenient access from Mumbai and allows ample time to explore the site along with other Panchgani attractions."
  },
  {
    title: "Devrai Art Village",
    description:
      "Devrai Art Village is a cultural and artistic hub in Panchgani where visitors can experience local art, crafts, and performances. Travelers can interact with artists, buy handicrafts, and enjoy workshops. A cab ride provides comfortable access, allowing tourists to combine cultural exploration with scenic sightseeing."
  },
  {
    title: "Dhom Dam",
    description:
      "Dhom Dam is a popular spot near Panchgani for boating, photography, and picnics. The surrounding hills and water create a peaceful environment for relaxation. Traveling by cab ensures convenient access and flexibility to include this destination alongside other sightseeing spots in Panchgani."
  },
  {
    title: "Lingmala Waterfall",
    description:
      "Lingmala Waterfall, located near Panchgani, is a beautiful natural attraction surrounded by lush greenery. Visitors can enjoy trekking, photography, and the serene atmosphere of the cascading water. A cab service allows safe and comfortable travel, giving enough time to explore the waterfall and nearby viewpoints."
  },
  {
    title: "Krishna Valley Viewpoint",
    description:
      "Krishna Valley Viewpoint offers sweeping views of the valley and Dhom Dam, making it ideal for photography and nature appreciation. Visitors can enjoy peaceful walks and scenic vistas. Using a cab ensures convenient travel from Mumbai and flexible scheduling for a full day of sightseeing."
  },
  {
    title: "Panchgani Market",
    description:
      "Panchgani Market is the main shopping area where visitors can buy local produce, handicrafts, and souvenirs. Travelers can explore local culture, taste regional delicacies, and shop for unique items. A cab ride provides hassle-free transport, making it easy to combine market visits with scenic and cultural attractions."
  }
],




services: [
{
name: "Mumbai to Panchgani Cab",
description: "Mumbai to Panchgani cab service provides comfortable travel from Mumbai to the scenic hill station of Panchgani. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys. Professional drivers with experience on ghat roads ensure safe and timely travel. Pickup is available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for weekend trips, family vacations, and tourist sightseeing. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options make travel planning convenient. Transparent pricing and reliable service ensure a stress-free cab booking experience."
},
{
name: "Mumbai to Panchgani Taxi",
description: "Mumbai to Panchgani taxi service offers convenient and reliable transportation for travelers visiting the peaceful hill station. Comfortable AC vehicles ensure smooth highway travel and pleasant long-distance journeys. Experienced drivers ensure safe driving along the scenic ghat routes. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for couples, families, and tourists planning hill station holidays. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure timing allows passengers to schedule trips easily. Reliable taxi services ensure safe and enjoyable travel."
},
{
name: "Mumbai to Panchgani Cab Service",
description: "Mumbai to Panchgani cab service offers dependable intercity transportation for passengers traveling to this popular hill destination. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Professional drivers ensure safe driving on mountain roads and highways. Pickup services are available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for family holidays, corporate trips, and tourist travel. Spacious vehicles provide comfortable seating for long-distance journeys. Flexible booking options allow easy trip scheduling. Transparent pricing ensures a reliable cab service."
},
{
name: "Mumbai to Panchgani Taxi Service",
description: "Mumbai to Panchgani taxi service provides efficient and comfortable road travel for passengers planning hill station trips. AC vehicles ensure relaxed travel across highways and scenic ghat roads. Skilled drivers ensure safe driving and punctual arrival at the destination. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for weekend trips, family travel, and sightseeing tours. Spacious seating ensures comfortable travel during the journey. Flexible booking options allow convenient scheduling. Affordable fares ensure a smooth taxi travel experience."
},
{
name: "Cab from Mumbai to Panchgani",
description: "Cab from Mumbai to Panchgani offers a private and comfortable travel option for visitors heading to the hill station. Our AC vehicles ensure smooth highway journeys and pleasant travel experiences. Professional drivers provide safe driving through scenic ghat roads and highways. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for couples, families, and small groups visiting Panchgani. Spacious interiors ensure relaxed seating during the journey. Flexible departure timing allows convenient trip planning. Reliable cab services ensure safe and stress-free travel."
},
{
name: "Taxi from Mumbai to Panchgani",
description: "Taxi from Mumbai to Panchgani offers dependable transportation for travelers seeking comfortable road travel. AC vehicles ensure pleasant journeys across highways and hill routes. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup is available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for family trips, tourist travel, and weekend vacations. Clean interiors and spacious seating ensure passenger comfort. Flexible booking options allow convenient travel scheduling. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Panchgani Cab Booking",
description: "Mumbai to Panchgani cab booking allows travelers to reserve vehicles easily for hill station journeys. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Panchgani for sightseeing and vacations. Flexible one-way and round-trip booking options are available. Reliable booking service ensures hassle-free travel planning."
},
{
name: "Mumbai to Panchgani Taxi Booking Online",
description: "Mumbai to Panchgani taxi booking online offers quick and convenient reservation for passengers planning hill station travel. Instant booking confirmation helps travelers schedule trips easily. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers provide safe and professional driving services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, couples, and tourists. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Panchgani Cab Price",
description: "Mumbai to Panchgani cab price offers affordable and transparent travel options for passengers visiting the hill station. Clear pricing details allow travelers to understand travel costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip travel. Budget-friendly pricing ensures convenient cab travel."
},
{
name: "Mumbai to Panchgani Taxi Fare",
description: "Mumbai to Panchgani taxi fare is calculated using transparent per-kilometer pricing to ensure clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel and pleasant journeys. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for families and tourists planning hill station trips. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Panchgani One Way Cab",
description: "Mumbai to Panchgani one way cab service is perfect for travelers who need a drop service without return charges. This option helps reduce travel costs while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance travel. Professional drivers ensure safe highway driving and smooth travel on ghat roads. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Panchgani for short trips. Flexible departure timing ensures convenient scheduling. Reliable one-way cab service ensures affordable travel."
},
{
name: "Mumbai to Panchgani Round Trip Taxi",
description: "Mumbai to Panchgani round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return timing allows travelers to explore Panchgani comfortably. Comfortable AC vehicles ensure relaxed travel during long-distance journeys. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for family vacations, sightseeing tours, and weekend trips. Spacious vehicles ensure comfortable travel for groups. Reliable round-trip taxi service ensures smooth travel planning."
},
{
name: "Mumbai to Panchgani Innova Cab",
description: "Mumbai to Panchgani Innova cab service provides spacious and comfortable travel for families and group travelers. The premium MPV offers ample seating space and luggage capacity for hill station trips. AC interiors ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe highway and ghat road driving. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for family vacations and group sightseeing tours. Comfortable seating ensures relaxed travel for passengers. Reliable Innova cab service ensures convenient hill station travel."
}
],

tableData: [
["Mumbai to Panchgani Cab","Mumbai to Panchgani Taxi"],
["Mumbai to Panchgani Cab Service","Mumbai to Panchgani Taxi Service"],
["Cab from Mumbai to Panchgani","Taxi from Mumbai to Panchgani"],
["Mumbai to Panchgani Cab Booking","Mumbai to Panchgani Taxi Booking Online"],
["Mumbai to Panchgani Cab Price","Mumbai to Panchgani Taxi Fare"],
["Mumbai to Panchgani One Way Cab","Mumbai to Panchgani Round Trip Taxi"],
["Mumbai to Panchgani Innova Cab","Best Cab Mumbai to Panchgani"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through the scenic ghat roads from Mumbai to Panchgani. They are familiar with the hill routes, curves, and weather conditions, ensuring a safe and comfortable journey to this popular hill station."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Panchgani cab bookings. We clearly explain per-kilometer fares, toll charges, and travel packages before booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to start early in the morning or travel late at night, Omshree Cabs provides 24/7 cab booking and customer support for your Mumbai to Panchgani journey."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable and refreshing ride for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible travel plans including one-way cabs, round trips, and same-day return packages. Travelers can customize their trip schedule according to their travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Panchgani begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Hill Station Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Panchgani trips. Our punctual service, professional drivers, and comfortable vehicles ensure a relaxing hill station journey."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Panchgani by cab?", answer: "The distance from Mumbai to Panchgani is approximately 245 km and the journey usually takes around 5–6 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Panchgani cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Panchgani." },
  { question: "Which vehicles are available for Mumbai to Panchgani travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Panchgani cab bookings." },
  { question: "Can we visit Mahabaleshwar during the Panchgani trip?", answer: "Yes, many travelers combine Panchgani travel with Mahabaleshwar sightseeing during the trip." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return packages?", answer: "Yes, same-day return cab packages from Mumbai to Panchgani are available." },
  { question: "Can we stop during the journey for food or sightseeing?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or scenic viewpoints." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday seasons when Panchgani receives many tourists." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Shah",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Panchgani trip. The driver was punctual and handled the ghat roads very well. The car was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Kulkarni",
    feedback:
      "Our family trip to Panchgani with Omshree Cabs was fantastic. On-time pickup, smooth driving, and transparent pricing made the journey very enjoyable.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Panchgani Cab",
  "description": "Book Mumbai to Panchgani Cab with Omshree Cab for comfortable hill station travel. Reliable taxi service from Mumbai to Panchgani with Innova and other cabs for one-way or round trips. Affordable fares, easy online booking, and safe travel for your Panchgani trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1950"
  }
};








  return (
    <div>
   <Helmet>
  <title>Mumbai to Panchgani Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Panchgani Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Panchgani with Innova and other cabs for one-way or round trips. Affordable fares and easy online cab booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>   



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopanchganicab;